<template>
  <div class="about-facts card-shade">
    <div class="about-facts-title">
      <h2>{{title}}</h2>
    </div>
    <h1>{{value}}</h1>
    <p>{{text}}</p>
  </div>
</template>

<script>
export default {
  name: 'AboutFacts',
  props: {
    title: String,
    value: String,
    text: String,
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.about-facts {
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1%;
  width : 290px;
  height : 233px;
  border-radius : 12px;
  border-top: none !important;
  background : linear-gradient(0deg, rgba(124, 202, 204, 1) 0%, rgba(137, 206, 208, 1) 5.76%, rgba(154, 211, 213, 1) 16.41%, rgba(165, 215, 216, 1) 29.69%, rgba(172, 217, 218, 1) 48.31%, rgba(174, 218, 219, 1) 100%);

  h1{
    font-size: 4.5em;
    padding: 15px 0 0;
    margin: auto;
  }

  h2{
    padding: 20px 0;
    margin: 0;
  }

  p{
    white-space: pre-line;
  }
}

.about-facts-title{
  padding: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-height : 70px;
  background : rgba(255, 255, 255, 0.2);
}
</style>
